import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import FontIcon from 'components/FontIcon';
import removeAnimationClass from 'utils/Animations';
import BuildChildren from 'utils/BuildChildren';
import classNames from 'classnames';
import classes from './SiteNavBMobileFlyout.module.scss';

const SiteNavBMobileFlyout = (props) => {
  const {
    onBackClick,
    children,
    onAnimationEnd,
    scroll,
    show,
    animate,
  } = props;

  const flyoutRef = useRef(null);

  const getContainerClass = () => {
    if (animate) {
      return show ? classes.flyIn : classes.flyOut;
    }

    return show ? classes.stayIn : classes.stayOut;
  };

  return (
    <div
      className={classNames(getContainerClass(), !scroll && classes.noScroll)}
      onAnimationEnd={() => {
        removeAnimationClass(
          flyoutRef,
          classes.flyIn,
          classes.stayIn,
          classes.flyOut,
          classes.stayOut,
        );
        onAnimationEnd();
      }}
      ref={flyoutRef}
    >
      <div className={classes.wrapper}>
        <button
          className={classes.backButton}
          type='button'
          onClick={onBackClick}
          aria-label='back'
        >
          <FontIcon icon='fas fa-chevron-left' className={classes.backIcon} />
          <span>
            Back
          </span>
        </button>
        {BuildChildren(children)}
      </div>
    </div>
  );
};

SiteNavBMobileFlyout.propTypes = {
  children: PropTypes.node,
  onBackClick: PropTypes.func,
  onAnimationEnd: PropTypes.func,
  scroll: PropTypes.bool,
  show: PropTypes.bool,
  animate: PropTypes.bool,
};

export default SiteNavBMobileFlyout;
